module.exports = __webpack_public_path__ + "static/media/logo.68de1cc0.png";